import React, { useState } from 'react'

import { useFreeBuyBonusStore } from '@stores'

import { BSModalTemplate, FBBDecline, FBBFooter, FBBMultipleBonuses, FBBSingleBonus, FBBEndBonus } from '@components'
import { Bonus, BonusSystemDeclineState, BonusSystemState } from 'game-ui-types'
import { useTranslation } from '@amusnet/translations/react'

const FreeBuyBonusSystem: React.FC = () => {
    const bonusSystemState = useFreeBuyBonusStore((state) => state.bonusSystemState)
    const bonusSystemDeclineState = useFreeBuyBonusStore((state) => state.bonusSystemDeclineState)
    const declinedBonusesIds = useFreeBuyBonusStore((state) => state.declinedBonusesIds)
    const bonuses = useFreeBuyBonusStore((state) => state.bonuses)
    const styles = useFreeBuyBonusStore((state) => state.styles)
    const isModalOpened = useFreeBuyBonusStore((state) => state.isModalOpened)
    const setIsModalOpened = useFreeBuyBonusStore((state) => state.setIsModalOpened)

    const { t } = useTranslation()

    const [selectedBonus, setSelectedBonus] = useState<Bonus | undefined>()

    const isInDeclineState =
        bonusSystemDeclineState === BonusSystemDeclineState.SINGLE_BONUS_DECLINE ||
        bonusSystemDeclineState === BonusSystemDeclineState.MULTIPLE_BONUSES_DECLINE ||
        bonusSystemDeclineState === BonusSystemDeclineState.BUNDLE_DECLINE

    const renderContent = () => {
        if (isInDeclineState) {
            switch (bonusSystemDeclineState) {
                case BonusSystemDeclineState.SINGLE_BONUS_DECLINE:
                    return <FBBDecline bonus={selectedBonus} />
                case BonusSystemDeclineState.BUNDLE_DECLINE:
                    return <FBBDecline bonus={selectedBonus} />
                case BonusSystemDeclineState.MULTIPLE_BONUSES_DECLINE:
                    return <FBBDecline />
                default:
                    return
            }
        }

        switch (bonusSystemState) {
            case BonusSystemState.SINGLE_BONUS_INITIAL:
                return <FBBSingleBonus updateSelectedBonus={setSelectedBonus} />
            case BonusSystemState.MULTIPLE_BONUSES_INITIAL:
                return <FBBMultipleBonuses setSelectedBonus={setSelectedBonus} />
            case BonusSystemState.END:
                return <FBBEndBonus />
        }
    }

    return (
        <BSModalTemplate
            isModalOpened={isModalOpened}
            setIsModalOpened={setIsModalOpened}
            title={t('gameui.bonusSystem.fbbTitle')}
            body={renderContent()}
            footer={<FBBFooter bonus={selectedBonus} />}
            titleColor={styles.headerLabelColor}
            gradient={styles.footerAndHeaderBackground}
            bonuses={bonuses}
            bonusSystemState={bonusSystemState}
            declinedBonusesIds={declinedBonusesIds}
        />
    )
}

export default FreeBuyBonusSystem
